import React, { useContext, useEffect, useState } from 'react';
import _ from 'lodash';
import { connect, useDispatch } from 'react-redux';
import loadable from '@loadable/component';
import {
  saveUserDrug,
  deleteSavedDrug
} from '../../../services/Api/SavedDrugs/savedDrugService';
import {
  fetchSavedDrugs,
  setSavedDrugs,
  setIsFetchDrug,
  setSavedDrugClick
} from '../../../actions/userDrug';
import { AuthContext } from '../../../Contexts';
import useIsDesktop from '../../../hooks/useIsDesktop';
import toast from '../../Toaster/toast';

const AuthenticatedModal = loadable(() =>
  import('../../HomeDeliveryNew/AuthenticateModal')
);

const SaveDrug = ({
  drugNDC,
  quantity,
  kclass,
  isCustomQuantity,
  ...props
}) => {
  const [addDrugFailureMsg, setAddDrugFailureMsg] = useState('');
  const [isSignupModalOpen, setSignupModal] = useState(false);
  const [isFromCallBack, setIsFromCallBack] = useState(false);
  const [isHoverActive, setIsHoverActive] = useState(false);
  const userData = useContext(AuthContext)?.userData;
  const isDesktop = useIsDesktop();
  const isLoggedIn = userData?.isLoggedIn;
  useEffect(() => {
    if (isFromCallBack && isLoggedIn) {
      saveDrugToBasket();
    }
  }, [isLoggedIn, isFromCallBack]);

  const dispatch = useDispatch();

  let isDrugAddedinBasket = false;
  if (isLoggedIn) {
    isDrugAddedinBasket =
      !_.isEmpty(props.savedDrugsData.drugItems) &&
      props.savedDrugsData.drugItems.filter(
        item => item.ndc == drugNDC && item.quantity == quantity
      ).length > 0;
  }
  const saveDrugToBasket = async () => {
    const saveUserDrugResponse = await saveUserDrug(
      drugNDC,
      quantity,
      isCustomQuantity
    );
    if (saveUserDrugResponse && saveUserDrugResponse.success) {
      _.triggerGTMVirtualPageViewEvent({
        event: 'saveDrug'
      });
      dispatch(setIsFetchDrug(true));
      props.fetchSavedDrugs();
      toast.success('Drug saved', {
        showIcon: true,
        link: { href: '/save-drugs?drug=true', label: 'View saved' }
      });
    } else {
      const errorMessage =
        saveUserDrugResponse.message.code === 6
          ? 'This drug is already saved.'
          : 'Something went wrong.';
      setAddDrugFailureMsg(errorMessage);
      setTimeout(() => {
        setAddDrugFailureMsg('');
      }, 3000);
    }
  };

  const handleDeleteSavedDrug = async () => {
    const clickedDrugItem =
      props.savedDrugsData.drugItems &&
      props.savedDrugsData.drugItems.filter(
        drug => drug.ndc == drugNDC && drug.quantity == quantity
      );
    const deleteDrugDrugsResponse = await deleteSavedDrug(
      props.savedDrugsData.saveDrugId,
      clickedDrugItem[0].id
    );
    if (deleteDrugDrugsResponse && deleteDrugDrugsResponse.saveDrugId) {
      toast.success('Drug unsaved', {
        showIcon: true
      });
      props.setSavedDrugs(deleteDrugDrugsResponse);
    }
  };

  const handleAddDeleteDrug = () => {
    if (isLoggedIn) {
      if (isDrugAddedinBasket) {
        handleDeleteSavedDrug();
      } else {
        saveDrugToBasket();
      }
    } else {
      dispatch(setSavedDrugClick('save drug'));
      setSignupModal(true);
    }
  };

  return (
    <div className={kclass} onMouseLeave={() => setIsHoverActive(false)}>
      <button
        onClick={handleAddDeleteDrug}
        className={`savedWrapper ${
          (props.ispricingInProgress || props.isFetchDrug) && 'disabled'
        }`}
        role="link"
        onMouseEnter={() =>
          isDesktop ? setIsHoverActive(true) : setIsHoverActive(false)
        }
      >
        <span
          className={`saveImage ${
            isHoverActive
              ? isDrugAddedinBasket
                ? 'unSaveNewImg'
                : 'saveNewImg'
              : isDrugAddedinBasket
              ? 'savedDrugImg'
              : ''
          }`}
        ></span>
        <span
          className={`actionSave ${isDrugAddedinBasket ? 'unsaveActive' : ''}`}
        >
          {`${
            isDrugAddedinBasket && isHoverActive
              ? 'Unsave'
              : isDrugAddedinBasket
              ? 'Saved'
              : 'Save'
          }`}{' '}
          drug
        </span>
        <span className="tooltipForSaveDrug">
          <i className="arrowUp"></i>
          <span>
            {`${isDrugAddedinBasket ? 'Unsave' : 'Save'}`} this prescription
            drug
          </span>
        </span>
      </button>
      {!_.isEmpty(addDrugFailureMsg) && (
        <div className="notification visible savedDrugNotification">
          {addDrugFailureMsg}
          <span
            className="close-button"
            onClick={() => setAddDrugFailureMsg('')}
          >
            ×
          </span>
        </div>
      )}
      {isSignupModalOpen && (
        <div className="mainModal afterSignupmodal">
          <div
            className="transparentBg"
            onClick={() => setSignupModal(false)}
          ></div>
          <div className="signUpModal">
            <AuthenticatedModal
              hideAuthenticateModal={() => {
                dispatch(setSavedDrugClick(''));
                setSignupModal(false);
                setIsFromCallBack(true);
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

// TODO remove below logic and use UseSelctor and useDispatch

function mapStateToProps(state) {
  return {
    savedDrugsData: state.userDrugs.savedDrugs,
    isFetchDrug: state.userDrugs.isFetchDrug
  };
}

const mapDispatchToProps = dispatch => {
  return {
    fetchSavedDrugs: () => dispatch(fetchSavedDrugs()),
    setSavedDrugs: data => dispatch(setSavedDrugs(data))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SaveDrug);
